// Контент лендинга стоматологии КИТ, Ярославль
// Заказчик заменит тексты/фото на финальные после подтверждения

// Часы работы задаются ТОЛЬКО здесь — шапка, футер, карта и страница
// благодарности берут их отсюда, чтобы расписание не разъезжалось по сайту.
export const hours = [
  { days: "ПН–ПТ", time: "09:00–21:00" },
  { days: "СБ–ВС", time: "09:00–18:00" },
];

export const workingHoursText = hours.map((h) => `${h.days}: ${h.time}`).join(" · ");

export const clinic = {
  name: "Стоматология КИТ",
  shortName: "КИТ",
  city: "Ярославль",
  address: "Малый Московский переулок, 1/17",
  phone: "8 (4852) 23-10-22",
  phoneRaw: "+74852231022",
  email: "mail@kit-stom.ru",
  website: "https://implantacia-yaroslavl.ru/",
  workingHours: workingHoursText,
  license: "№Л041-01132-76/00643627 от 14 марта 2023 г.",
};

export const offer = {
  implantFrom: "28 900",
  implantOld: "43 000",
  crownFrom: "33 000",
  crownOld: "46 000",
  turnkeyFrom: "61 900",
  turnkeyOld: "89 000",
};

export const pains = [
  {
    icon: "ShieldAlert",
    title: "Беспокоит дискомфорт?",
    text: "Опасаетесь возможного дискомфорта во время процедуры — мы расскажем о всех вариантах анестезии и седации.",
  },
  {
    icon: "Wallet",
    title: "Пугает цена?",
    text: "Думаете, что имплантация — это недоступная роскошь, а честных цен вы нигде не увидите.",
  },
  {
    icon: "HelpCircle",
    title: "Не доверяете врачам?",
    text: "Сомневаетесь в опыте специалистов и качестве материалов, не знаете, кому можно доверить улыбку.",
  },
  {
    icon: "Clock",
    title: "Боитесь долгого лечения?",
    text: "Кажется, что имплантация — это месяцы неудобств, боли и ограничений в обычной жизни.",
  },
];

export const benefits = [
  {
    icon: "Smile",
    title: "Полное восстановление функции и эстетики",
    text: "Ешьте, улыбайтесь и говорите уверенно — как со своими зубами.",
  },
  {
    icon: "Moon",
    title: "Лечение под седацией",
    text: "Современные анестетики и медикаментозный сон по показаниям — максимальный комфорт пациента.",
  },
  {
    icon: "ShieldCheck",
    title: "Пожизненная гарантия на имплант",
    text: "Инвестиция в ваше здоровье на десятки лет вперёд.",
  },
  {
    icon: "Sparkles",
    title: "3D-моделирование улыбки",
    text: "Идеальный результат вы увидите ещё до начала лечения.",
  },
  {
    icon: "Target",
    title: "Хирургические шаблоны",
    text: "Точность установки до долей миллиметра, минимум вмешательства.",
  },
  {
    icon: "CreditCard",
    title: "Беспроцентная рассрочка",
    text: "Сделайте мечту об улыбке реальностью уже сегодня — до 24 месяцев.",
  },
];

export const usps = [
  {
    icon: "HeartPulse",
    title: "Комфорт во время лечения",
    text: "Седация и опытные анестезиологи. Минимум стресса от стоматологии.",
  },
  {
    icon: "ShieldCheck",
    title: "Гарантия на результат",
    text: "2 года гарантии от врача и пожизненная гарантия на сам имплант.",
  },
  {
    icon: "Microscope",
    title: "Новейшее оборудование",
    text: "КТ, микроскоп, хирургические шаблоны — для максимальной точности работы.",
  },
  {
    icon: "Award",
    title: "Опытные врачи с регалиями",
    text: "Команда специалистов с дипломами Dentsply Sirona и подтверждённым опытом.",
  },
  {
    icon: "Wallet",
    title: "Беспроцентная рассрочка",
    text: "До 24 месяцев без переплат. Ваше здоровье доступно уже сейчас.",
  },
  {
    icon: "Beaker",
    title: "Своя зуботехническая лаборатория",
    text: "Изготавливаем коронки и протезы без посредников — быстрее и качественнее.",
  },
  {
    icon: "HeartHandshake",
    title: "Персональный куратор",
    text: "Поможем с проживанием, закажем такси, ответим на любой вопрос — 24/7.",
  },
];

export const doctors = [
  {
    name: "Петрожицкая Валерия Олеговна",
    role: "Хирург-имплантолог",
    experience: "11 лет",
    operations: "3 000+ операций",
    photo: "/doctors/petrozhitskaya.jpg",
    about: "Проводит комплексную имплантацию любой сложности. Работает с системами Osstem, Astra Tech, Nobel.",
    certificates: [
      "/certificates/petrozhitskaya/cert1.png",
      "/certificates/petrozhitskaya/cert2.png",
      "/certificates/petrozhitskaya/cert3.png",
      "/certificates/petrozhitskaya/cert4.jpg",
    ],
  },
  {
    name: "Буров Константин Дмитриевич",
    role: "Хирург-имплантолог",
    experience: "5 лет",
    operations: "1 000+ операций",
    photo: "/doctors/burov.jpg",
    about: "Специализируется на одномоментной имплантации и костной пластике. Член профессиональных ассоциаций.",
    certificates: [
      "/certificates/burov/cert1.jpg",
      "/certificates/burov/cert2.png",
      "/certificates/burov/cert3.jpg",
    ],
  },
  {
    name: "Айдунов Адильхан Мурадович",
    role: "Хирург-имплантолог",
    experience: "5 лет",
    operations: "1 000+ операций",
    photo: "/doctors/aydunov.jpg",
    about: "Работает с применением хирургических шаблонов. Постоянно повышает квалификацию на международных конференциях.",
    certificates: [
      "/certificates/aydunov/cert1.png",
      "/certificates/aydunov/cert2.png",
      "/certificates/aydunov/cert3.png",
    ],
  },
  {
    name: "Авакян Михаил Давидович",
    role: "Стоматолог-ортопед",
    experience: "20 лет",
    operations: null,
    photo: "/doctors/avakyan.jpg",
    about: "Эстетическое протезирование на имплантах, керамика, цирконий. Точность и натуральный вид — гарантирован.",
    certificates: [
      "/certificates/avakyan/cert1.jpg",
      "/certificates/avakyan/cert2.jpg",
      "/certificates/avakyan/cert3.jpg",
      "/certificates/avakyan/cert4.jpg",
    ],
  },
  {
    name: "Черниченко Виктория Сергеевна",
    role: "Врач-стоматолог-ортопед",
    experience: "19 лет",
    operations: null,
    photo: "/doctors/chernichenko.webp",
    about: "Высококлассный специалист в области протезирования зубов. Работает со всеми видами ортопедических конструкций.",
    certificates: [],
  },
];

export const processSteps = [
  {
    num: "01",
    title: "Консультация и диагностика",
    text: "Знакомство с врачом, 3D-снимок (КТ), составление персонального плана лечения с прозрачной сметой.",
  },
  {
    num: "02",
    title: "Хирургический этап",
    text: "Безболезненная установка импланта под контролем хирурга с использованием шаблона. По желанию — во сне.",
  },
  {
    num: "03",
    title: "Период приживления",
    text: "3–6 месяцев на остеоинтеграцию. На это время — временная конструкция, чтобы ничто не мешало жить привычно.",
  },
  {
    num: "04",
    title: "Протезирование",
    text: "Установка постоянной циркониевой коронки, идеально подобранной по цвету и форме в нашей лаборатории.",
  },
];

export const prices = [
  {
    title: "Имплант Osstem",
    old: "31 800",
    now: "28 900",
    desc: "Премиальные корейские импланты с пожизненной гарантией производителя.",
    popular: false,
  },
  {
    title: "Коронка из циркония",
    old: "46 000",
    now: "33 000",
    desc: "Изготавливается в собственной лаборатории. Эстетично, прочно, без окисления.",
    popular: false,
  },
  {
    title: "Имплантация под ключ",
    old: "89 000",
    now: "61 900",
    desc: "Установка импланта, установка формирователя десны, наложение швов, циркониевая коронка.",
    popular: true,
  },
];

export const faqs = [
  {
    q: "Болезненна ли установка импланта?",
    a: "Установка проводится под современной местной анестезией; по показаниям возможна седация. Большинство пациентов отмечают, что испытали значительно меньше дискомфорта, чем при удалении зуба. Точные ощущения и варианты обезболивания обсуждаются с врачом на консультации.",
  },
  {
    q: "Сколько времени занимает процедура имплантации?",
    a: "Сама установка одного импланта — 30–45 минут. Полный цикл с приживлением и протезированием занимает 3–6 месяцев в зависимости от клинической ситуации.",
  },
  {
    q: "Сколько стоит имплантация под ключ?",
    a: `${offer.turnkeyFrom} ₽ за готовый зуб под ключ: имплант Osstem, установка формирователя десны, наложение швов и циркониевая коронка. Если по результатам КТ-диагностики понадобятся дополнительные процедуры, врач заранее обсудит их с вами на консультации.`,
  },
  {
    q: "Какую гарантию вы даёте?",
    a: "2 года гарантии на работу врача и пожизненная гарантия на сам имплант от производителя (Osstem, Astra Tech, Nobel). Это закрепляется договором.",
  },
  {
    q: "Можно ли сделать имплантацию в рассрочку?",
    a: "Да. Беспроцентная рассрочка до 24 месяцев от банков-партнёров. Решение — за 15 минут прямо в клинике.",
  },
  {
    q: "Как долго приживается имплант?",
    a: "В среднем 3–6 месяцев. В это время вы живёте обычной жизнью — на период приживления устанавливается временная конструкция.",
  },
  {
    q: "Что делать, если я боюсь стоматологов?",
    a: "Именно для вас у нас клиника без белых халатов и клинической обстановки. По желанию — лечение во сне под контролем анестезиолога. Персональный куратор будет рядом на всех этапах.",
  },
];

export const testimonials = [
  {
    name: "Елена М.",
    age: "42 года",
    text: "Боялась имплантации 5 лет. Здесь сделали во сне — проснулась, и имплант уже стоит. Через 4 месяца поставили коронку, не отличить от своих. Спасибо Валерии Олеговне!",
    rating: 5,
    service: "Имплантация Osstem + циркониевая коронка",
  },
  {
    name: "Андрей К.",
    age: "51 год",
    text: "Ставил 4 импланта. Цена оказалась ровно такой, как сказали на первой консультации — никаких сюрпризов. Рассрочку оформили за 20 минут. Результатом очень доволен.",
    rating: 5,
    service: "Комплексная имплантация 4 зубов",
  },
  {
    name: "Ольга В.",
    age: "36 лет",
    text: "Приезжала из Костромы. Куратор помогла с гостиницей и такси — всё организовано на высшем уровне. Врачи работают аккуратно и вежливо, атмосфера в клинике приятная.",
    rating: 5,
    service: "Имплантация Astra Tech",
  },
];

export const quizQuestions = [
  {
    q: "Сколько зубов вас беспокоит?",
    options: ["1 зуб", "2–3 зуба", "4 и более", "Полное восстановление челюсти"],
  },
  {
    q: "Когда был потерян или удалён зуб?",
    options: ["Недавно (до 3 мес.)", "3–12 месяцев назад", "Более года назад", "Зуб ещё на месте, но сильно разрушен"],
  },
  {
    q: "Что для вас важнее всего?",
    options: ["Цена и рассрочка", "Безболезненность и комфорт", "Долговечность и гарантии", "Эстетика и естественный вид"],
  },
  {
    q: "Рассматриваете ли вы лечение во сне?",
    options: ["Да, определённо", "Возможно", "Нет, не требуется"],
  },
  {
    q: "Когда вы хотите начать лечение?",
    options: ["Как можно скорее", "В ближайший месяц", "В течение 2–3 месяцев", "Пока просто изучаю вопрос"],
  },
];
